import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";
import { CourseByIdApiResponse} from "../../../../types/courses/curses-by/cursesBy";
import {setCourseById} from "../../../../slice/courses/curses-by/cursesBy";
import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


export const fetchCourseById = createAsyncThunk(
    "courses/fetchCourseById",
    async (curseId: string | undefined, thunkAPI) => {


        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }

            const { token } = JSON.parse(authToken);

            const response = await axios.get<CourseByIdApiResponse>(`/api/courses/buy/${curseId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            thunkAPI.dispatch(setCourseById(response.data));
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
